import { createSelector } from 'reselect';

import type { IWhiteLabellingState, IWhiteLabellingConfig } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Redux state with Immutable.js Maps; TODO: DEV-20793
export const selectWhiteLabellingDomain = () => (state: any) =>
  state.get('whiteLabelling');

export const selectWhiteLabelling = () =>
  createSelector(
    selectWhiteLabellingDomain(),
    (substate: IWhiteLabellingState) => substate.whiteLabellingConfig
  );

createSelector(
  selectWhiteLabellingDomain(),
  (substate: IWhiteLabellingState) => substate.loading
);

export const selectShowCheckboxBranding = () =>
  createSelector(
    selectWhiteLabelling(),
    (substate: IWhiteLabellingConfig) => substate.showCheckboxBranding
  );

export const selectIsWhiteLabellingConfigured = () =>
  createSelector(
    selectWhiteLabellingDomain(),
    (substate: IWhiteLabellingState) => substate.isWhiteLabellingConfigured
  );
